import React, { useContext, useMemo } from "react";
import { RicosNodeContext, RicosNodeContextProvider } from "./../../ricos-context/index.js";
const TableRow = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { parentNode } = useContext(RicosNodeContext);
  const rowIndex = useMemo(() => {
    const idx = parentNode?.nodes?.findIndex((row) => row.id === node.id);
    return idx != null && idx >= 0 ? idx : nodeIndex;
  }, [parentNode, node.id, nodeIndex]);
  const style = { height: parentNode?.tableData?.dimensions?.rowsHeight?.[rowIndex] || "auto" };
  return /* @__PURE__ */ React.createElement("tr", { style }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode, parentIndex: rowIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes ?? [] })));
};
const TableRowRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(TableRow, { key: node.id, node, ...props });
};
var table_row_default = TableRowRenderer;
export {
  table_row_default as default
};
//# sourceMappingURL=table-row.js.map

import "@wix/ricos/css/plugin-table-viewer.global.css";